import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import "components/General/Form/Form.css"

const CustomBanner = (props) => {
	return (
		<div
			className="background_med_blue main_custom_banner"
		>
			<b>
				<TextTheme message={props.message} className="text_large text_white main_custom_banner_font" />
			</b>
		</div>
	);
};

export default CustomBanner;
